import axios from 'axios'

class Data {
	constructor (filters) {
		this.data = []
		this.observersCollection = []
		const keys = Object.keys(filters)
		keys.forEach(key => {
			this[key] = filters[key]
		})
	}

	get () {
		return this.data.slice()
	}

	async fetch (
		from = 0,
		to = from + 3,
		numberOfGuest,
		categoryFilters,
		eventTypeFilters
	) {
		try {
			const res = await axios.post(
				window.baseURL + 'index.php',
				this.getParams({
					start: from,
					end: to,
					numberOfGuest,
					categoryFilters,
					eventTypeFilters
				})
			)
			if (res.data.data[0].length < to - from) this.notify(true)
			this.add(res.data.data[0])
		} catch (error) {
			throw new Error(error)
		}
	}

	getParams (options) {
		const params = new URLSearchParams()
		params.append('plugin', 'GetContent')
		params.append('option', 'com_ajax')
		params.append('format', 'json')
		params.append('start', options.start)
		params.append('limit', (options.end - options.start))
		params.append('order', this.order)
		params.append('id', this.categoryID)
		this.setFilters(params, options)
		return params
	}


	setFilters (params, options) {
		const keys = Object.keys(options).slice(3)
		const {numberOfGuest} = options
		const numberOfGuestFilter = this.parseGuestToValid(numberOfGuest)
		const setFilters = keys.filter(key => options[key] && options[key].length)
		const filters = []
		if (setFilters.length) {
			setFilters.forEach(filter => {
				filters.push({
					id: this[filter],
					value: options[filter]
				})
			})
		}
		if (numberOfGuestFilter) {
			filters.push(numberOfGuestFilter[0])
			filters.push(numberOfGuestFilter[1])
		}
		if (filters.length === 0) return
		params.append('filtr', JSON.stringify(filters))
	}

	parseGuestToValid (field) {
		if (!field || field.value === '') return false;

		if (~field.value.indexOf('-')) {
			const from = field.value.split('-')[0]
			const to = field.value.split('-')[1]
			return [{
				id: field.default ? this.capacityStandingFilters : this.capacitySeatedFilters,
				value: 'gte:' + Number(from)
			}, {
				id: this['minCapacity'],
				value: 'lte:' + Number(to)
			}]
		}
		return [{
			id: field.default ? this.capacityStandingFilters : this.capacitySeatedFilters,
			value: 'gte:' + Number(field.value)
		}, {}]
	}

	addObserver (observer) {
		this.observersCollection.push(observer)
	}

	notify (val) {
		this.observersCollection.forEach(observer => observer(val))
	}

	add (dataArr) {
		if (Object.prototype.toString.call(dataArr) !== '[object Array]') {
			throw new Error('You can only add data of Arrays')
		}
		dataArr.forEach(mainElement => {
			if (!this.isThereTheSameAlias(mainElement, this.data)) {
				this.data.push(mainElement)
			}
		})
	}

	isThereTheSameAlias (mainElement, data) {
		let isTheSameAlias = false
		data.forEach(element => {
			if (mainElement.alias === element.alias) isTheSameAlias = true
		})
		return isTheSameAlias
	}

	clear () {
		this.data = []
	}
}

export default Data



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/src/data/Data.js